export enum StudentClassIdentifier {
  CurrentStudentClassIsAvailable = 'CurrentStudentClassIsAvailable',
  CurrentStudentClassNotFound = 'CurrentStudentClassNotFound',
  CurrentStudentClassHasExpired = 'CurrentStudentClassHasExpired',
  CurrentStudentClassHasNotStarted = 'CurrentStudentClassHasNotStarted',
}
